import {
  AfterViewInit,
  Component,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LayoutService } from '../services/layout.service';
import { Subscription } from 'rxjs';
import { ConfigService } from '../services/config.service';
import { AuthService } from '../auth/auth.service';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
})
export class NavbarComponent implements OnInit, AfterViewInit, OnDestroy {
  currentLang = 'en';
  toggleClass = 'ft-maximize';
  placement = 'bottom-right';
  userRoles = [];
  public isCollapsed = true;
  layoutSub: Subscription;
  @Output()
  toggleHideSidebar = new EventEmitter<boolean>();

  public config: any = {};

  constructor(
    public translate: TranslateService,
    private _layoutService: LayoutService,
    private _configService: ConfigService,
    private _auth: AuthService,
  ) {
    const browserLang: string = translate.getBrowserLang();
    translate.use(browserLang.match(/en|es|pt|de/) ? browserLang : 'en');

    this.layoutSub = this._layoutService.changeEmitted$.subscribe(
      (direction) => {
        const dir = direction.direction;

        if (dir === 'rtl') {
          this.placement = 'bottom-left';
        } else if (dir === 'ltr') {
          this.placement = 'bottom-right';
        }
      },
    );
  }

  ngOnInit(): void {
    this.userRoles = this._auth.currentUserValue?.roles || [];
    this.config = this._configService.templateConf;
  }

  ngAfterViewInit(): void {
    if (this.config.layout.dir) {
      setTimeout((): void => {
        const dir = this.config.layout.dir;

        if (dir === 'rtl') {
          this.placement = 'bottom-left';
        } else if (dir === 'ltr') {
          this.placement = 'bottom-right';
        }
      }, 0);
    }
  }

  ngOnDestroy(): void {
    if (this.layoutSub) {
      this.layoutSub.unsubscribe();
    }
  }

  changeLanguage(language: string): void {
    this.translate.use(language);
  }

  // toggleClassfn(): void {
  //   if (this.toggleClass === 'ft-maximize') {
  //     this.toggleClass = 'ft-minimize';
  //   } else {
  //     this.toggleClass = 'ft-maximize';
  //   }
  // }

  toggleNotificationSidebar(): void {
    this._layoutService.emitNotiSidebarChange(true);
  }

  toggleSidebar(): void {
    const appSidebar = document.getElementsByClassName('app-sidebar')[0];

    if (appSidebar.classList.contains('hide-sidebar')) {
      this.toggleHideSidebar.emit(false);
    } else {
      this.toggleHideSidebar.emit(true);
    }
  }

  logout(): void {
    this._auth.logout();
  }
}
